import { createFileRoute } from '@tanstack/react-router'

import { UserSettings } from '@/widgets/user-settings'

export const Route = createFileRoute('/_app/settings/products-and-entities')({
  component: RouteComponent,
})

export const ProductsAndEntitiesRoute = Route

function RouteComponent() {
  return <UserSettings />
}
